module.exports = __webpack_public_path__ + "media/nl.e336d50a.svg";